export default __webpack_public_path__ + "static/media/thumnail-2.5de28276.jpg";